import { BpmRuntimeDevkitModule } from "./bpm-runtime-devkit/bpm-runtime-devkit.module";
import { BpmRuntimeDevkitWebCmpModule } from "../public-api";

/**
 * Module或者ModuleWithProviders
 */
const BPM_RUNTIME_DEVKIT_MODULES: any[] = [
    BpmRuntimeDevkitModule.forRoot(),
    BpmRuntimeDevkitWebCmpModule,
];

const BPM_DEVKIT_MODULES: any[] = [
    ...BPM_RUNTIME_DEVKIT_MODULES,
];

export { BPM_RUNTIME_DEVKIT_MODULES };
export { BPM_DEVKIT_MODULES };